import { Component, Input, ViewChild } from '@angular/core'
import { ModalDirective } from 'ngx-bootstrap/modal'

@Component({
  selector: 'modal-container',
  templateUrl: './modal-container.component.html',
  styleUrls: ['./modal-container.component.scss'],
})
export class ModalContainerComponent {
  @ViewChild('childModal') public childModal: ModalDirective
  @ViewChild('modalBtnShow') public modalBtnShowEl: any
  @Input() public headerIconClass: string
  @Input() public headerTitle: string
  @Input() public headerTitleAfterTranslatedTitle: string
  @Input() public modalHeaderBgColorClass: string
  @Input() public modalBodyBgColorClass: string
  @Input() public modalFooterBgColorClass: string
  @Input() public translateTitle = true
  @Input() public hasBackdrop = true
  @Input() public ignoreBackdropClick = false
  @Input() public noPaddingModalBody = false
  @Input() public isSmallModal = false
  @Input() public isModalForTypeOut = false
  @Input() public isLargeModal = false
  @Input() public isExtraLargeModal = false
  @Input() public isModalFromRight = false
  @Input() public isModalFromLeft = false
  @Input() public isFullWidth = false
  @Input() public isModalInModal = false
  @Input() public isLoading = false
  @Input() public isHideBtnHidden = false
  @Input() public isModalForProductChoose = false
  @Input() public isModalForStatsSearch = false
  @Input() public hasCustomHeader = false
  @Input() public readonly = false
  modalBtnShowTopOffset: number
  modalBtnShowLeftOffset: number
  modalBtnShowWidth: number
  availableHeight: number
  modalProductChoosePadding = 15

  public showChildModal(): void {
    this.modalBtnShowTopOffset = this.modalBtnShowEl?.nativeElement?.getBoundingClientRect().top + window.scrollY
    const viewportBottom = window.scrollY + window.innerHeight
    this.availableHeight = viewportBottom - this.modalBtnShowTopOffset - this.modalProductChoosePadding

    this.modalBtnShowLeftOffset = this.modalBtnShowEl?.nativeElement?.getBoundingClientRect().left
    this.modalBtnShowWidth =
      window.innerWidth -
      (this.modalBtnShowEl?.nativeElement?.getBoundingClientRect().left +
        (window.innerWidth - this.modalBtnShowEl?.nativeElement?.getBoundingClientRect().right))
    this.childModal.show()
  }

  public hideChildModal(): void {
    this.childModal.hide()
  }

  public isShown(): boolean {
    return this.childModal.isShown
  }
}
